import React, { FC } from 'react';
import { Dialog } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { PrimaryButton } from '@clover/web-lib-core/components';
import { App } from '../../../../models/app';
import { AppActions } from '../types';
import { AppActionDisclaimer } from '../../../Common/AppActionDisclaimer';
import { SecondaryButton } from '@clover/web-lib-core/dist/components';

interface ComponentProps {
  app: App;
  open: boolean;
  closeYelpModal: () => void;
}

export const YelpConnectModal: FC<ComponentProps> = (
  {
    app,
    closeYelpModal,
    open,
  }): Nullable<JSX.Element> => {
  const { t } = useTranslation();
  const actionButtonText = t(AppActions.YelpConnect);

  return (
    <Dialog onClose={closeYelpModal} open={open} maxWidth={false}
            PaperProps={{ classes: { root: styles.yelpConnectDialog } }}>
      <h3>{t('app_details.yelp_modal_info')}</h3>
      <div className={styles.buttonContainer}>
        <PrimaryButton
          onClick={() => window.location.href = '/dashboard?claimYelpBusiness=true'} data-testid='primaryButtonYelp'>{t('buttons.continue')}</PrimaryButton>
        <SecondaryButton onClick={closeYelpModal} className={styles.cancel} data-testid='secondaryButtonYelp'>
          {t('buttons.cancel')}
        </SecondaryButton>
      </div>
      <AppActionDisclaimer app={app} actionText={actionButtonText} variant='body1' />
    </Dialog>
  );
};
